import {
	composeListerQuery,
	translateQueryString,
} from './../utilities/lister-utilities';
import TRANSLATIONS from '../translations/translations@default.json';

export const GOT_LISTER = 'GOT_LISTER';
export const GOT_NEXT_PAGE = 'GOT_NEXT_PAGE';
export const IS_LOADING = 'IS_LOADING';
export const FACET_TOGGLED = 'FACET_TOGGLED';
export const FACET_NAME_TO_SCROLL_TO = 'FACET_NAME_TO_SCROLL_TO';
export const SORT_OPTION_CHANGED = 'SORT_OPTION_CHANGED';
export const NEW_DISMISS_FILTERS_URL = 'NEW_DISMISS_FILTERS_URL';
export const NEW_FILTERS_URL = 'NEW_FILTERS_URL';
export const UPDATE_CURRENT_PAGE_NUMBER = 'UPDATE_CURRENT_PAGE_NUMBER';
export const SHOW_FILTERED_PRODUCTS = 'SHOW_FILTERED_PRODUCTS';
export const GOT_PRODUCTS_IN_BASKET = 'GOT_PRODUCTS_IN_BASKET';
export const SET_PRODUCT_CARD_VIEW = 'SET_PRODUCT_CARD_VIEW';
export const ADD_PRODUCT_TO_COMPARE = 'ADD_PRODUCT_TO_COMPARE';
export const REMOVE_PRODUCT_FROM_COMPARE = 'REMOVE_PRODUCT_FROM_COMPARE';
export const GET_COMPARED_PRODUCTS = 'GET_COMPARED_PRODUCTS';
export const GOT_COMPARED_PRODUCTS = 'GOT_COMPARED_PRODUCTS';
export const FACET_SELECTED = 'FACET_SELECTED';
export const FACETS_SELECTED = 'FACETS_SELECTED';
export const CLEAR_ALL_SELECTED_FACETS = 'CLEAR_ALL_SELECTED_FACETS';
export const PAGE_SIZE_CHANGED = 'PAGE_SIZE_CHANGED';
export const ADD_TO_BASKET_EVENT = 'ADD_TO_BASKET_EVENT';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const UPDATE_LAZY_LOAD_STATES = 'UPDATE_LAZY_LOAD_STATES';
export const SET_ACTIVE_DRAWER = 'SET_ACTIVE_DRAWER';
export const OPEN_FINANCE_SLIDEOUT = 'OPEN_FINANCE_SLIDEOUT';
export const SET_EXPERIMENT_SWITCHES = 'SET_EXPERIMENT_SWITCHES';
export const LISTER_CLICK_THROUGH = 'LISTER_CLICK_THROUGH';
export const UPDATE_DOCUMENT_INFORMATION = 'UPDATE_DOCUMENT_INFORMATION';

export const isLoading = (bool) => {
	return {
		type: IS_LOADING,
		payload: bool,
	};
};

export const gotLister = (res) => (dispatch) => {
	if (!res.Products && res.RedirectUrl) {
		window.location.href = res.RedirectUrl;
	}

	dispatch({
		type: GOT_LISTER,
		payload: res,
	});

	dispatch({ type: UPDATE_DOCUMENT_INFORMATION });
};

export const getStub = () => (dispatch) => {
	return fetch(
		`https://media.ao.com/lister/assets/stub/stub%40${TRANSLATIONS.general.locale}.json`
	)
		.then((res) => res.json())
		.then((json) => dispatch(gotLister(json)))
		.catch((error) => {
			throw new Error(error);
		});
};

export const getDealsStub = () => (dispatch) => {
	return fetch(
		`https://media.ao.com/lister/assets/stub/dealsStub%40${TRANSLATIONS.general.locale}.json`
	)
		.then((res) => res.json())
		.then((json) => dispatch(gotLister(json)))
		.catch((error) => {
			throw new Error(error);
		});
};

export const gotNextPage = (res) => {
	return {
		type: GOT_NEXT_PAGE,
		payload: res,
	};
};

export const updateFiltersUrl = (url) => (dispatch) => {
	dispatch({
		type: NEW_FILTERS_URL,
		payload: url,
	});
};

export const getLister = (url, action) => {
	return (dispatch) => {
		dispatch(isLoading(true));

		return composeListerQuery(url)
			.then(({ data }) => {
				if (typeof data !== 'object' || !data) {
					throw new Error(data);
				}

				dispatch(updateFiltersUrl(url));
				dispatch(gotLister(data));

				if (action) {
					if (!action.type) {
						action = {
							type: '',
							...action,
						};
					}

					dispatch(action);
				}
			})
			.then(() => {
				if (action) {
					// If we explicitly don't want to track return and do not update.
					if (action?.trackHistory === false) {
						return;
					}

					// Update query string replace pagesize/page with localized version
					url = translateQueryString(url);

					// Push a new entry to history, on facet/sort change, etc.
					if (action?.trackHistory) {
						history.pushState('', '', url);
					} else {
						// Replace last entry in history, pageSize change where we dont want a new entry.
						history.replaceState(history.state, null, url);
					}
				}
			})
			.catch((err) => {
				throw new Error(err);
			});
	};
};

export const gotProductsInBasket = (productsInBasketObject) => {
	return {
		type: GOT_PRODUCTS_IN_BASKET,
		payload: productsInBasketObject,
	};
};

export const getNextPage = (url, action) => {
	return (dispatch) => {
		dispatch(isLoading(true));
		return composeListerQuery(url)
			.then(({ data }) => {
				dispatch(gotNextPage(data));
			})
			.then(() => {
				if (action) {
					// If we explicitly don't want to track return and do not update.
					if (action.trackHistory === false) {
						return;
					}

					// Update query string replace pagesize/page with localized version
					url = translateQueryString(url);

					// Push a new entry to history, on facet/sort change, etc.
					if (action.trackHistory) {
						history.pushState('', '', url);
					} else {
						// Replace last entry in history, pageSize change where we dont want a new entry.
						history.replaceState(history.state, null, url);
					}
				}
			})
			.catch((err) => {
				throw new Error(err);
			});
	};
};

export const facetToggled = (facet, isSmallAndAbove) => (dispatch) => {
	dispatch(isLoading(true));
	dispatch(
		getLister(facet.Url, {
			type: FACET_TOGGLED,
			payload: {
				name: facet.Name,
				url: facet.Url,
			},
			trackHistory: isSmallAndAbove,
		})
	);
};

export const updateFacetNameToScrollTo = (facetTarget) => (dispatch) => {
	dispatch({
		type: FACET_NAME_TO_SCROLL_TO,
		payload: facetTarget,
	});
};

export const sortOptionChanged = (option) => (dispatch) => {
	dispatch(
		getLister(option.Url, {
			type: SORT_OPTION_CHANGED,
			payload: {
				sortKey: option.SortKey,
				sortPhrase: option.SortPhrase,
			},
			trackHistory: true,
		})
	);
};

export const pageSizeChanged = (option) => (dispatch) => {
	dispatch(
		getLister(option.Url, {
			type: PAGE_SIZE_CHANGED,
			payload: {
				Size: option.Size,
				Url: option.Url,
			},
		})
	);
};

export const updateDismissFiltersUrl = (url) => {
	return {
		type: NEW_DISMISS_FILTERS_URL,
		payload: url,
	};
};

export const updateCurrentPageNumber = (number) => {
	return {
		type: UPDATE_CURRENT_PAGE_NUMBER,
		payload: number,
	};
};

export const showFilteredProducts = (array) => (dispatch) => {
	dispatch({
		type: SHOW_FILTERED_PRODUCTS,
		payload: array,
	});
};

export const setProductCardView = (string, hasInitialized = true) => (
	dispatch
) => {
	dispatch({
		type: SET_PRODUCT_CARD_VIEW,
		payload: string,
		hasInitialized: hasInitialized,
	});
};

export const addProductToCompare = (sku, category) => (dispatch) => {
	dispatch({
		type: ADD_PRODUCT_TO_COMPARE,
		payload: {
			sku: sku,
			category: category,
		},
	});
};

export const removeProductFromCompare = (sku, category) => (dispatch) => {
	dispatch({
		type: REMOVE_PRODUCT_FROM_COMPARE,
		payload: {
			sku: sku,
			category: category,
		},
	});
};

export const gotComparedProducts = (array) => (dispatch) => {
	dispatch({
		type: GOT_COMPARED_PRODUCTS,
		payload: array,
	});
};

export const facetsSelected = (facetsData) => (dispatch) => {
	dispatch({
		type: FACETS_SELECTED,
		payload: facetsData,
	});
};

export const facetSelected = (facetData) => (dispatch) => {
	dispatch({
		type: FACET_SELECTED,
		payload: facetData,
	});
};

export const clearAllSelectedFacets = () => {
	return {
		type: CLEAR_ALL_SELECTED_FACETS,
	};
};

export const addToBasketEvent = (eventName, ProductCode) => {
	return {
		type: ADD_TO_BASKET_EVENT,
		payload: {
			eventName,
			ProductCode,
		},
	};
};

export const closeSlideOutDrawer = () => {
	return {
		type: CLOSE_DRAWER,
	};
};

export const setActiveDrawer = (name, detail) => (dispatch) => {
	dispatch({
		type: SET_ACTIVE_DRAWER,
		payload: name,
		detail,
	});
};

export const openFinanceSlideout = (payload) => (dispatch) => {
	dispatch({
		type: OPEN_FINANCE_SLIDEOUT,
		payload,
	});

	const { productSku } = payload;
	window.dispatchEvent(
		new CustomEvent('ListerPageFinanceComponent:Open', {
			detail: { productSku },
		})
	);
};

export const setExperimentSwitches = (switches) => (dispatch) => {
	dispatch({
		type: SET_EXPERIMENT_SWITCHES,
		payload: switches,
	});
};

export const listerClickThrough = (productID) => (dispatch) => {
	dispatch({
		type: LISTER_CLICK_THROUGH,
		payload: { productID },
	});
};
